import React from 'react';

import {
  Form,
  Input,
  Button,
  Card,
  Row,
  Col,
  Checkbox,
  Typography,
  Divider,
  Space,
  Popconfirm,
  message,
  Modal,
  Collapse,
} from 'antd';

const { Panel } = Collapse;

const FleetDetails = ({ fleetLogoURL, fleetAddress }) => {
  return (
    <Collapse
      defaultActiveKey={['1']}
      style={{ marginBottom: 24 }}
      expandIconPosition="end"
    >
      <Panel
        header="Fleet Details"
        key="1"
        style={{ width: '100%', boxSizing: 'border-box', padding: '0' }}
      >
        <Row gutter={24}>
          <Col span={8}>
            <div
              style={{
                border: '1px solid #e5e5e5',
                borderRadius: 8,
                minHeight: 120,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#fff',
              }}
            >
              <div style={{ textAlign: 'center' }}>
                <div style={{ marginBottom: 8 }}>Add Logo:</div>
                <img
                  src={fleetLogoURL}
                  alt="logo"
                  style={{
                    width: 80,
                    height: 80,
                    objectFit: 'contain',
                    borderRadius: 8,
                  }}
                />
              </div>
            </div>
          </Col>
          <Col span={16}>
            <div
              style={{
                border: '1px solid #e5e5e5',
                borderRadius: 8,
                minHeight: 120,
                background: '#fff',
                padding: 16,
                fontSize: 16,
              }}
            >
              <b>Fleet Address:</b>
              <div style={{ marginTop: 8 }}>{fleetAddress}</div>
            </div>
          </Col>
        </Row>
      </Panel>
    </Collapse>
  );
};

export default FleetDetails;
